import './index.less'
import '@utils/scrollend.js'

// anchor
export default class MembershipAnchor {
  constructor() {
    this.anchorSection = document.querySelector('[data-sticky-anchor-section]')
    this.anchorWrap = document.querySelector('[data-membership-anchor-wrap]')
    this.anchorItems = document.querySelectorAll('[data-membership-anchor-item]')
    this.anchorDeco = document.querySelector('[data-membership-anchor-deco]')

    // 无活动
    this.noActivityDOM = document.querySelector('[data-membership-no-activity]')

    // 左右箭头
    this.leftArrowBtn = document.querySelector('.membership-anchor-left-arrow')
    this.rightArrowBtn = document.querySelector('.membership-anchor-right-arrow')

    this.activeIndex = 0    // 当前 active anchor
    this.scrolling = false  // 滚动开关

    if (this.anchorItems.length > 0) {
      this.init()

      const debounceResizeHandler = debounce(() => this.resize(), 100);
      window.addEventListener('resize', debounceResizeHandler)

      // 监听页面滚动事件
      const throttleResizeHandler = throttle(() => this.watchScroll(), 100);
      window.addEventListener('scroll', throttleResizeHandler)

      // 页面重载之前
      window.addEventListener('beforeunload', () => {
        // 存储信息到 sessionStorage
        sessionStorage.setItem('jk_membership_anchor_index', this.activeIndex)
        sessionStorage.setItem('jk_membership_scroll_y', window.scrollY)
      })
    }

    // 如果开启了无活动，则清空 anchor item
    if (this.noActivityDOM) {
      this.anchorSection.parentElement.style.position = 'relative'
      this.anchorWrap.innerHTML = ''
      this.leftArrowBtn.classList.add('hidden')
      this.rightArrowBtn.classList.add('hidden')

      if (this.isMobile()) {
        this.anchorSection.style.height = '0px'
      }
    }
  }
  init() {
    this.initArrowDisplay()

    this.anchorItems.forEach((item, index) => {
      item.onclick = () => {
        if (this.scrolling) return

        // 更新箭头的 disabled
        this.updateArrowDisabled(index)

        // 处理纵向滚动
        this.scrollToAnchorDOM(item)

        // 处理横向平滑滚动
        this.handleSmoothScroll(item)

        if (this.activeIndex !== index) {
          this.activeIndex = index
        }
        // 如果点击本身
        else {
          this.scrolling = false
        }
      }
    })

    this.anchorWrap.classList.add('transition-all', 'duration-300')

    // 左箭头 点击
    this.leftArrowBtn.onclick = () => this.handleArrow('left')
    // 右箭头 点击
    this.rightArrowBtn.onclick = () => this.handleArrow('right')

    // 处理刷新页面后的回显
    this.handleRefresh()
  }
  // 处理刷新页面后的回显
  handleRefresh() {
    const _activeIndex = sessionStorage.getItem('jk_membership_anchor_index') || 0
    const _scroll_y = sessionStorage.getItem('jk_membership_scroll_y') || 0

    // 更新 Item 的显示状态
    this.updateItem(this.anchorItems[_activeIndex], true)

    this.activeIndex = _activeIndex
    window.scrollTo(0, _scroll_y)

    // 清除 sessionStorage
    sessionStorage.removeItem('jk_membership_anchor_index')
    sessionStorage.removeItem('jk_membership_scroll_y')
  }
  // 初始化 左右箭头 的显示状态
  initArrowDisplay() {
    if (this.anchorWrap.scrollWidth > this.anchorWrap.offsetWidth && !this.isMobile()) {
      this.leftArrowBtn.classList.remove('hidden')
      this.rightArrowBtn.classList.remove('hidden')
      this.anchorWrap.classList.remove('lg:flex-center')
    } else {
      this.leftArrowBtn.classList.add('hidden')
      this.rightArrowBtn.classList.add('hidden')
      this.anchorWrap.classList.add('lg:flex-center')
    }
  }
  // 更新 Item 的显示状态
  updateItem(item, init) {
    // 初始化时，不需要动画
    if (!init) {
      this.anchorDeco.classList.add('transition-all', 'duration-300')
    }

    this.anchorItems.forEach(t => t.classList.remove('active'))
    item.classList.add('active')
    
    this.anchorDeco.style.width = item.offsetWidth + 'px'
    this.anchorDeco.style.left = item.offsetLeft + 'px'
    this.anchorDeco.style.opacity = 1
  }
  // handle Arrow
  handleArrow(direction) {
    if (this.scrolling) return

    const updateIndex =
      direction === 'left'
        ? Math.max(this.activeIndex - 1, 0)
        : Math.min(this.activeIndex + 1, this.anchorItems.length - 1)

    this.activeIndex = updateIndex

    // 更新箭头的 disabled
    this.updateArrowDisabled(updateIndex)

    const item = this.anchorItems[updateIndex]

    // 处理纵向滚动
    this.scrollToAnchorDOM(item)
    
    // 处理横向滚动
    this.handleSmoothScroll(item)
  }
  // 更新箭头的 显示状态
  updateArrowDisabled(index) {
    if (index === 0) {
      this.leftArrowBtn.setAttribute('disabled', true)
    }
    else if (index === this.anchorItems.length - 1) {
      this.rightArrowBtn.setAttribute('disabled', true)
    }
    else {
      this.leftArrowBtn.removeAttribute('disabled')
      this.rightArrowBtn.removeAttribute('disabled')
    }
  }
  resize() {
    // 更新 左右箭头 的显示状态
    this.initArrowDisplay()

    const { id, } = this.anchorItems[0]?.dataset
    if (id && document.getElementById(id)) {
      const offsetTop = document.getElementById(id)?.offsetTop
      if (window.scrollY >= offsetTop) {
        this.scrollToAnchorDOM(this.anchorItems[this.activeIndex])
      } else {
        // 更新 item 的显示状态
        this.updateItem(this.anchorItems[this.activeIndex])
      }
    }
  }
  scrollToAnchorDOM(item) {
    // 更新 item 的显示状态
    this.updateItem(item)

    const id = item.dataset.id
    if (id && document.getElementById(id)) {
      const offsetTop = document.getElementById(id).offsetTop
      const sectionHeight = this.anchorSection.offsetHeight // anchor 容器的高度
      this.scrolling = true

      window.scrollTo({
        top: offsetTop - sectionHeight,
        behavior: 'smooth',
      })

      // 监听滚动结束
      document.addEventListener('scrollend', () => {
        this.scrolling = false
      })
    }
  }
  watchScroll() {
    if (this.scrolling) return

    const sectionHeight = this.anchorSection.offsetHeight // anchor 容器的高度

    const maxIndex = Math.min(this.activeIndex + 1, this.anchorItems.length - 1)
    const minIndex = Math.max(this.activeIndex - 1, 0)

    if (window.scrollY > document.getElementById(this.anchorItems[maxIndex]?.dataset?.id)?.offsetTop - sectionHeight) {
      this.activeIndex = maxIndex
    }
    else if (window.scrollY < document.getElementById(this.anchorItems[minIndex]?.dataset?.id)?.offsetTop - sectionHeight) {
      this.activeIndex = minIndex
    }

    // 更新箭头的 disabled
    this.updateArrowDisabled(this.activeIndex)

    const item = this.anchorItems[this.activeIndex]

    // 更新 Item 的显示状态
    this.updateItem(item)

    // 处理横向平滑滚动
    this.handleSmoothScroll(item)
  }
  isMobile() {
    const clientWidth = document.documentElement.clientWidth || document.body.clientWidth
    return clientWidth < 1024
  }
  // 横向平滑滚动
  handleSmoothScroll(item) {
    // 设置滑动时间为 500 毫秒
    const duration = 300;

    // 获取元素当前的滚动位置
    const startScrollLeft = this.anchorWrap.scrollLeft;

    const scrollLeft = item.offsetLeft + (item.offsetWidth / 2) - (window.innerWidth / 2);
    const targetScrollLeft = scrollLeft - startScrollLeft

    // 记录动画开始时间
    let startTime = null;

    // 处理横向滚动
    const smoothScroll = (currentTime) => {
      // 如果是第一次执行,记录开始时间
      if (!startTime) {
        startTime = currentTime;
      }

      // 计算已经经过的时间
      const elapsedTime = currentTime - startTime;

      // 计算当前滚动位置
      const scrollLeft = this.easeInOutQuad(elapsedTime, startScrollLeft, targetScrollLeft, duration);

      // 设置新的滚动位置
      this.anchorWrap.scrollLeft = scrollLeft;

      // 如果滚动未完成,继续下一帧动画
      if (elapsedTime < duration) {
        requestAnimationFrame(smoothScroll);
      }
    }

    requestAnimationFrame(smoothScroll);
  }
  // 缓动函数,用于计算当前滚动位置
  easeInOutQuad(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  }
}
